(function () {
  if (customElements.get('myd-countdown')) return;

  class MydCountdown extends HTMLElement {
    connectedCallback() {
      this.endDate = this.dataset.endDate;
      this.endTime = this.dataset.endTime;
      this.daysEl = this.querySelector('[data-days]');
      this.hoursEl = this.querySelector('[data-hours]');
      this.minutesEl = this.querySelector('[data-minutes]');
      this.secondsEl = this.querySelector('[data-seconds]');

      if (!this.endDate) {
        this.showExpired();
        return;
      }

      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      if (this.interval) clearInterval(this.interval);
    }

    parseEnd() {
      var time = String(this.endTime || '00:00').trim();
      if (/^\d{1,2}:\d{2}$/.test(time)) time += ':00';
      return new Date(String(this.endDate).trim() + 'T' + time).getTime();
    }

    tick() {
      var end = this.parseEnd();
      if (Number.isNaN(end)) {
        this.showExpired();
        return;
      }

      var distance = end - Date.now();
      if (distance < 0) {
        this.showExpired();
        return;
      }

      var days = Math.floor(distance / 86400000);
      var hours = Math.floor((distance % 86400000) / 3600000);
      var minutes = Math.floor((distance % 3600000) / 60000);
      var seconds = Math.floor((distance % 60000) / 1000);

      if (this.daysEl) this.daysEl.textContent = String(days).padStart(2, '0');
      if (this.hoursEl) this.hoursEl.textContent = String(hours).padStart(2, '0');
      if (this.minutesEl) this.minutesEl.textContent = String(minutes).padStart(2, '0');
      if (this.secondsEl) this.secondsEl.textContent = String(seconds).padStart(2, '0');
    }

    showExpired() {
      if (this.interval) clearInterval(this.interval);
      this.classList.add('is-expired');
    }
  }

  customElements.define('myd-countdown', MydCountdown);
})();
